<template>
  <div class="bg-soft border rounded mt-2 p-3 font-mono break-all whitespace-pre-wrap">
    <vx-tooltip :text="tooltipText"
                :key="tooltipText"
                position="top"
                class="justify-end"
                :enabled="tooltipText.length > 0"
    >
      <span v-html="getTextWithSubstitutions"/>
    </vx-tooltip>
  </div>
</template>

<script>
import contentUtils from '@/utils/content.utils'
import clone from 'ramda/src/clone'

export default {
  name: 'JsonPreview',

  props: {
    data: {
      type: Object,
      default: null
    },
    formData: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      contextKey: null
    }
  },

  computed: {
    tooltipText() {
      if (this.contextKey) {
        return `<div style="font-size: 0.875rem; white-space: nowrap;">
          <b>Interpolation key:</b>
          </div>
          ${this.contextKey}
        `
      }
      return ''
    },

    getTextWithSubstitutions() {
      const data = clone(this.data || {})
      if (typeof data.body === 'string') {
        try {
          data.body = JSON.parse(data.body)
        } catch (err) {
          // Keep non-JSON response bodies as text.
        }
      }

      const formatted = JSON.stringify(data, null, 2)
      const escaped = formatted.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      return contentUtils.markSubstitutedText(escaped, this.formData?.data?.context)
    }
  },

  methods: {
    setupContextTooltipListeners() {
      this.$nextTick(() => {
        const contextElements = this.$el.querySelectorAll('.context-substituted')
        contextElements.forEach(element => {
          element.addEventListener('mouseenter', this.handleContextMouseEnter)
          element.addEventListener('mouseleave', this.handleContextMouseLeave)
        })
      })
    },

    removeContextTooltipListeners() {
      const contextElements = this.$el.querySelectorAll('.context-substituted')
      contextElements.forEach(element => {
        element.removeEventListener('mouseenter', this.handleContextMouseEnter)
        element.removeEventListener('mouseleave', this.handleContextMouseLeave)
      })
    },

    handleContextMouseEnter(event) {
      const contextKey = event.target.getAttribute('data-context')
      if (contextKey) {
        this.contextKey = contextKey
      }
    },

    handleContextMouseLeave() {
      this.contextKey = null
    }
  },

  mounted() {
    this.setupContextTooltipListeners()
  },

  updated() {
    this.removeContextTooltipListeners()
    this.setupContextTooltipListeners()
  },

  beforeDestroy() {
    this.removeContextTooltipListeners()
  }
}
</script>

<style lang="scss">
.context-substituted {
  text-decoration: underline;
  text-decoration-style: dotted;
}
</style>
